import { client } from "./shopifyClient";

export interface Variant {
  id: string;
  image: {
    url: string;
    altText: string | null;
  };
  selectedOptions: {
    name: string;
    value: string;
  }[];
  price: {
    amount: string;
    currencyCode: string;
  };
  compareAtPrice: {
    amount: string;
    currencyCode: string;
  };
  product: {
    title: string;
  };
}

export const getVariantsByIds = async (
  variantIds: string[]
): Promise<Variant[]> => {
  const query = `
  query GetVariants($variantIds: [ID!]!) {
    nodes(ids: $variantIds) {
      ... on ProductVariant {
        id
        image {
        url
        altText
      }
      selectedOptions {
          name
          value
        }
        price {
          amount
          currencyCode
        }
      compareAtPrice {
          amount
          currencyCode
        }
        product {
          title
        }
      }
    }
  }
`;

  const response = await client.request(query, {
    variables: {
      variantIds,
    },
  });

  const variants = response?.data?.nodes?.filter(Boolean) ?? [];

  return variants;
};
